import { fetchData, postData } from 'modules/Axios';
import { notifyFailure } from 'modules/Notifications';

export const defaultState = {
  brandAutomationRunning: false,
  brandAutomationStatus: {},
};

export const SET_BRAND_AUTOMATION_RUNNING = 'SET_BRAND_AUTOMATION_RUNNING';
export const setBrandAutomationRunning = (payload) => ({
  type: SET_BRAND_AUTOMATION_RUNNING,
  payload,
});

export const RESET_BRAND_AUTOMATION_STATUS = 'RESET_BRAND_AUTOMATION_STATUS';
export const resetBrandAutomationStatus = () => ({
  type: RESET_BRAND_AUTOMATION_STATUS,
});

export const SET_BRAND_AUTOMATION_STATUS = 'SET_BRAND_AUTOMATION_STATUS';
export const setBrandAutomationStatus = (payload) => ({
  type: SET_BRAND_AUTOMATION_STATUS,
  payload,
});

export const thoughtSpotBrandAutomation = ({
  brandData,
  thoughtSpotPrimaryConnection,
  snowflakeIntegration,
  snowflakeRole,
  snowflakeWarehouse,
  addBridgAdmins,
}) => {
  const { id: brandId } = brandData;
  const runThoughtSpotSetupUrl = `/brands/${brandId}/integrations/thoughtspot/run-setup`;

  return async (dispatch, getState) => {
    try {
      dispatch(setBrandAutomationRunning(true));
      const submissionResponse = await dispatch(postData(runThoughtSpotSetupUrl, {
        /* eslint-disable camelcase */
        thoughtspot_primary_connection_id: thoughtSpotPrimaryConnection?.id,
        snowflake_integration_id: snowflakeIntegration?.id,
        snowflake_role: snowflakeRole,
        snowflake_warehouse: snowflakeWarehouse,
        grant_access_to_bridg_admin: addBridgAdmins,
        /* eslint-enable camelcase */
      }));
      const { id: jobId, message } = submissionResponse || {};
      if (jobId) {
        const jobStatusUrl = `/brands/${brandId}/integrations/thoughtspot/run-setup/${jobId}`;
        const getThoughtSpotSetupStatus = async () => {
          try {
            const response = await dispatch(fetchData(jobStatusUrl));
            dispatch(setBrandAutomationStatus(response));
            const { status } = response || {};
            if (status === 'IN_PROGRESS' || status === 'PENDING') {
              setTimeout(getThoughtSpotSetupStatus, 1000);
            } else {
              dispatch(setBrandAutomationRunning(false));
            }
          } catch (e) {
            throw new Error(e);
          }
        };
        getThoughtSpotSetupStatus();
      } else {
        throw new Error({ code: 'SUBMISSION_FAILURE', message: message ?? 'No job ID returned from automation submission' });
      }
    } catch (e) {
      const error = e?.response?.data?.error || e?.code || 'Error';
      const message = e?.response?.data?.message || e?.message || 'Unknown automation error';
      const errorMessage = `ThoughtSpot Brand Automation: ${error}: ${message}`;
      console.error(errorMessage, e);
      notifyFailure('ThoughtSpot brand automation failed. See console for details.', 5000);
      dispatch(setBrandAutomationRunning(false));
      dispatch(setBrandAutomationStatus({ ...getState().brands?.brandAutomationStatus, status: 'FAILED' }));
    }
  };
};

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_BRAND_AUTOMATION_RUNNING:
      return {
        ...state,
        brandAutomationRunning: action.payload,
      };
    case RESET_BRAND_AUTOMATION_STATUS:
      return {
        ...state,
        brandAutomationRunning: defaultState.brandAutomationRunning,
        brandAutomationStatus: defaultState.brandAutomationStatus,
      };
    case SET_BRAND_AUTOMATION_STATUS:
      return {
        ...state,
        brandAutomationStatus: action.payload,
      };
    default:
      return state;
  }
}
